import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, isRef as _isRef, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3946c574"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "マスメディアンを知ったきっかけを"),
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "教えてください")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "entry_career_text" }, "この項目は任意です", -1))
const _hoisted_5 = { class: "entry_base_input" }
const _hoisted_6 = { class: "entry_base_cue_list" }
const _hoisted_7 = {
  key: 0,
  class: "entry_base_cue_list_other"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_cue_list_other_label" }, "その他を選んだ方は、下記にきっかけを入力してください", -1))
const _hoisted_9 = { class: "entry_base_cue_list_other_input" }
const _hoisted_10 = { class: "entry_base_button" }
const _hoisted_11 = { class: "entry_base_button_prev" }
const _hoisted_12 = { class: "entry_base_button_next" }
const _hoisted_13 = { class: "entry_career_skip" }

import { onBeforeMount, ref, Ref } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/store';
import { useField, useForm } from 'vee-validate';
import { object, string, number } from 'yup';
import { getMasterDataListMedia, MasterDataMedia } from '@/api/masterDataEndpoint';
import { putMedia, getMedia } from '@/api/careersheetEndpoint';


import Indicator from '@/components/Indicator.vue';
import BaseRadioButton from '@/components/BaseRadioButton.vue';
import BaseTextareaForm from '@/components/BaseTextareaForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import { putUpdateCareerRegstatus } from '@/api/accountEndpoint';

type CuesConvert = {
  value: number;
  label: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CueView',
  setup(__props) {

const cuesList: Ref<MasterDataMedia[]> = ref([]);
const isLoading = ref(false);

const schema = object({
  selectedCueValue: number().required(),
  othersCue: string().label('きっかけ').max(200, VALIDATON_ERRORS.MAX_LENGTH),
});

const { errors } = useForm({
  validationSchema: schema,
});

const { value: selectedCueValue } = useField('selectedCueValue', undefined, {
  initialValue: store.getters['userRegistration/mediaId'],
});
const { value: othersCue } = useField('othersCue', undefined, {
  initialValue: store.getters['userRegistration/mediaNotes'],
});

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'c12' });
};
const transitionNextPage = async () => {
  isLoading.value = true;
 try {
    await putMedia({
      mediaId: selectedCueValue.value,
      mediaNotes: othersCue.value,
    });
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
  router.push({ name: 'c13' });
};
onBeforeMount(async () => {
  const [mstCueeList] = await Promise.all([getMasterDataListMedia()]);
  cuesList.value = mstCueeList;

  // 初期値設定
  const res = await getMedia();
  selectedCueValue.value = res.mediaId !== null ? Number(res.mediaId) : '';

});

const updateCareerRegstatus = async() => {
  await putUpdateCareerRegstatus();
};


return (_ctx: any,_cache: any) => {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 12,
          max: 12
        })
      ]),
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cuesList.value, (cue) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "entry_base_cue_list_item",
              key: cue.code
            }, [
              _createVNode(BaseRadioButton, {
                modelValue: _unref(selectedCueValue),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedCueValue) ? (selectedCueValue).value = $event : null)),
                value: cue.code,
                name: "cue",
                label: cue.name
              }, null, 8, ["modelValue", "value", "label"])
            ]))
          }), 128)),
          (_unref(selectedCueValue) === 14)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(BaseTextareaForm, {
                    modelValue: _unref(othersCue),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(othersCue) ? (othersCue).value = $event : null)),
                    name: "othersCue",
                    rows: 5,
                    placeholder: "入力してください。"
                  }, null, 8, ["modelValue"])
                ]),
                (_unref(errors).othersCue)
                  ? (_openBlock(), _createBlock(ErrorMessage, {
                      key: 0,
                      errors: [_unref(errors).othersCue]
                    }, null, 8, ["errors"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseButton, {
            onClick: transitionNextPage,
            theme: "primary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          class: "entry_career_skip_link",
          to: { name: 'd00' },
          onClick: updateCareerRegstatus
        }, {
          default: _withCtx(() => [
            _createTextVNode("入力せずに面談予約へ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})